import { render, staticRenderFns } from "./DetailIndication.vue?vue&type=template&id=f6ed55d8&scoped=true"
import script from "./DetailIndication.vue?vue&type=script&lang=js"
export * from "./DetailIndication.vue?vue&type=script&lang=js"
import style0 from "./DetailIndication.vue?vue&type=style&index=0&id=f6ed55d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ed55d8",
  null
  
)

export default component.exports